import { useAtomValue } from 'jotai';
import { tenantContextAtom } from '../../stores/auth.store';
import { useMemberships } from './use-memberships';

export function useValidatedTenantId(): string | null {
  const ctx = useAtomValue(tenantContextAtom);
  const { memberships } = useMemberships();
  const tenantId = ctx?.currentTenantId;

  if (!tenantId || memberships.length === 0) {
    return null;
  }

  return memberships.some((m) => m.tenantId === tenantId) ? tenantId : null;
}
